import uspCarousel from "./usp-carousel";

uspCarousel('.usp-block__row--carousel .usp-block__usp');
